import React from "react";
import { Card } from "./ui";
import { fmtBRL } from "../../CrmKanban/kanban/tokens";

const KpiLabel = ({ V, children }) => (
  <div
    style={{
      fontSize: V.kpiUpper ? 11 : 12,
      fontWeight: V.kpiUpper ? 700 : 800,
      letterSpacing: V.kpiUpper ? ".05em" : 0,
      textTransform: V.kpiUpper ? "uppercase" : "none",
      color: V.kpiLabelColor,
    }}
  >
    {children}
  </div>
);

const KpiValue = ({ V, children, color }) => (
  <div
    style={{
      fontSize: 28,
      fontWeight: 900,
      color: color || V.textStrong,
      marginTop: 2,
    }}
  >
    {children}
  </div>
);

// Linha 1 — 4 KPIs. Os 3 primeiros refletem os filtros (backend já recalcula).
const Kpis = ({ V, kpis, agFilterActive }) => (
  <div
    style={{
      display: "grid",
      gridTemplateColumns: "repeat(4,1fr)",
      gap: 12,
    }}
  >
    <Card V={V} style={{ gap: 2 }}>
      <KpiLabel V={V}>Em atendimento</KpiLabel>
      <KpiValue V={V}>{kpis.emAtendimento}</KpiValue>
      <div style={{ height: 15 }} />
    </Card>

    <Card V={V} style={{ gap: 2 }}>
      <KpiLabel V={V}>Aguardando</KpiLabel>
      <KpiValue V={V}>{kpis.aguardando}</KpiValue>
      <div
        style={{ fontSize: 11, fontWeight: 800, color: V.bad, marginTop: 2 }}
      >
        {!agFilterActive && kpis.aguardandoSlaEstourado > 0
          ? `${kpis.aguardandoSlaEstourado} com SLA estourado`
          : " "}
      </div>
    </Card>

    <Card V={V} style={{ gap: 2 }}>
      <KpiLabel V={V}>Resolvidos hoje</KpiLabel>
      <KpiValue V={V}>{kpis.resolvidosHoje}</KpiValue>
      <div
        style={{
          fontSize: 11,
          fontWeight: 800,
          color: V.sublabel,
          marginTop: 2,
        }}
      >
        {kpis.resolvidosHoje > 0 ? `TMR ${kpis.tmrMin}min` : " "}
      </div>
    </Card>

    <Card V={V} style={{ gap: 2 }}>
      <KpiLabel V={V}>Ganhos no mês</KpiLabel>
      <KpiValue V={V} color={V.money}>
        {fmtBRL(kpis.ganhosMes)}
      </KpiValue>
      <div
        style={{
          height: 5,
          borderRadius: 3,
          background: V.track,
          marginTop: 8,
          overflow: "hidden",
        }}
      >
        <div
          style={{
            height: "100%",
            width: `${kpis.metaPct}%`,
            background: V.good,
            borderRadius: 3,
          }}
        />
      </div>
      <div
        style={{
          fontSize: 10.5,
          fontWeight: 800,
          color: V.labelMuted,
          marginTop: 4,
        }}
      >
        {kpis.metaPct}% da meta ({fmtBRL(kpis.metaMensal)})
      </div>
    </Card>
  </div>
);

export default Kpis;
